import { useEffect } from 'react';
import { startSessionReplay, stopSessionReplay } from 'utils/mixpanel';

// Records a session replay while the component using it is mounted and enabled.
export const useSessionReplay = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    startSessionReplay();
    return stopSessionReplay;
  }, [enabled]);
};

export const SessionReplay: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useSessionReplay();
  return <>{children}</>;
};
